<!--
 * @Author: Nie Wie
 * @Date: 2020-02-22 17:54:23
 * @LastEditors: Nie Wie
 * @LastEditTime: 2020-03-30 16:11:28
 * @Description: 模块标题
 -->
<template>
<div class="part--title">
  <div class="part--title-icon"></div>
  <div class="part--title-txt"><span>{{title}}</span></div>
</div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default() {
        return '标题'
      },
    },
  },
}
</script>

<style lang="scss" scoped>
$height: 38px;
.part--title {
  display: flex;
  margin-bottom: 30px;
}
.part--title-txt {
  font-family: PingFangSC-Semibold,PingFang SC;
  font-size: $height;
  font-weight:600;
  text-indent: 15px;
  color: rgba(34,34,34,1);
  line-height: $height;
}
.part--title-icon {
  width: 7px;
  height: $height;
  border-radius: 3px;
  background: #005eff;
  transform: translateY(2px);
}
</style>
